'use client';

import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { useState } from 'react';

import { earnSummaryBunja } from '@flipster/features/src/shared/earn/state';
import { createSingleChoice } from '@flipster/react/design-system/chip';
import { css } from '@flipster/styled-system/css';
import { hstack } from '@flipster/styled-system/patterns';
import { PusdtCurrency, PusdtDisplayName } from '@flipster/utils/constants/currency';

import EarnHistory from './EarnHistory';
import HistoryLink from './HistoryLink';

type EarnHistoryTabType = 'total' | (string & {});
const Choice = createSingleChoice<EarnHistoryTabType>();

const EarnHistorySection = () => {
  const { earnSummaryAtom } = useBunja(earnSummaryBunja);
  const earnSummary = useAtomValue(earnSummaryAtom);

  const tabItems = [
    { label: 'Total', value: 'total' },
    ...(earnSummary?.currencies.map(({ currency }) => ({
      label: currency === PusdtCurrency ? `${PusdtDisplayName} - USDT` : currency,
      value: currency,
    })) ?? []),
  ];

  const [tab, setTab] = useState<string>('total');

  return (
    <section>
      <div className={hstack({ justify: 'space-between', mb: 16 })}>
        <h2 className={css({ textStyle: 'Title/S', color: 'content.default.level-4' })}>History</h2>
        <HistoryLink />
      </div>
      <Choice value={tab} onChange={setTab} css={{ overflowX: 'auto', mx: -16, px: 16, mb: 16 }}>
        {tabItems.map(({ label, value }) => (
          <Choice.Chip key={value} value={value} label={label} />
        ))}
      </Choice>
      <EarnHistory
        label={tabItems.find((t) => t.value === tab)?.label ?? ''}
        currency={tab === 'total' ? undefined : tab}
      />
    </section>
  );
};

export default EarnHistorySection;
